import React from "react";
import { useTranslation } from 'next-i18next';
import Image from "next/image";
import { CardsWrapper, Card } from "styles/cards";
import { TextHeadingTwo, Uppercase, TextHeadingThree, ParagraphText } from "styles/typography";
import { IntroWrapper, IconWrapper } from "styles/wrappers";
import { ServicesWrapper } from "./services.styles";
import { ServicesList } from "./services.utils";

const Services = () => {
   const { t } = useTranslation('common');
   const servicesList = ServicesList();
   return (
      <ServicesWrapper>
         <IntroWrapper>
            <Uppercase mw="470" center>
               {t('services-title')}
            </Uppercase>
            <TextHeadingTwo center mw="668">
               {t('services-subtitle')}
            </TextHeadingTwo>
         </IntroWrapper>

         <CardsWrapper col={3} gap={2.5}>
            {servicesList.map((item) => (
               <Card key={item.id}>
                  <IconWrapper
                     style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 50,
                        marginBottom: 20,
                     }}
                  >
                     <Image src={item.icon} alt={item.title} />
                  </IconWrapper>
                  <TextHeadingThree>{item.title}</TextHeadingThree>
                  <ParagraphText>{item.description}</ParagraphText>
               </Card>
            ))}
         </CardsWrapper>
      </ServicesWrapper>
   );
};

export { Services };
